




























import {api} from "@/api";
import Vue from "vue";
import Component from "vue-class-component";
import {Toast} from "vant";

@Component
export default class Order extends Vue {
    protected loading: boolean = false;
    protected lists: any[] = [];
    protected finished: boolean = true;
    protected searchValue: string = "";

    public async onSearch() {
        const resp = await api.orderSearch({orderId: this.searchValue});

        this.lists = resp;
    }

    public getStatusDesc(status: number) {
        let desc = "";
        switch (status) {
            case 2:
                desc = "创建订单";
                break;
            case 3:
                desc = "支付订单";
                break;
            case 4:
                desc = "使用产品";
                break;
            case 5:
                desc = "续费";
                break;
            case 6:
                desc = "退款";
                break;
        }

        return desc;
    }
}
